import { useApplicationContext } from '../../../modules/context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../../modules/users/AbilityContext';

const useCanChangeAdminOptions = () => {
  const { isAdminBrand } = useApplicationContext();
  const ability = useAbility();

  return isAdminBrand || ability.can('update', 'admin-options');
};

export default useCanChangeAdminOptions;
